module.exports = __webpack_public_path__ + "static/media/14.4b421bb5.jpg";